<template>
  <v-card elevation="0" outlined class="pa-0 h-100">
    <v-card-title class="px-4 py-2">
      <v-row no-gutters>
        <v-col cols="6">
          <span class="text-subtitle-1 font-weight-bold text-capitalize">
            {{ title }} <span v-if="required">*</span>
          </span>
        </v-col>
        <v-col cols="6" class="d-flex justify-end align-center">
          <v-checkbox
            v-model="isAllSelected"
            :label="isAllSelected ? 'Unselect All' : 'Select All'"
            hide-details="auto"
            class="pa-0 ma-0"
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-card-title>
    <v-divider class="py-2"></v-divider>
    <v-card-text class="py-0 px-4">
      <v-checkbox
        color="success"
        v-model="selectedDays"
        :label="`Monday `"
        value="monday"
        hide-details="auto"
        v-on="$listeners"
        v-bind="$attrs"
        dense
        outlined
      ></v-checkbox>
      <v-checkbox
        color="success"
        v-model="selectedDays"
        :label="`Tuesday `"
        value="tuesday"
        hide-details="auto"
        v-on="$listeners"
        v-bind="$attrs"
        dense
        outlined
      ></v-checkbox>
      <v-checkbox
        color="success"
        v-model="selectedDays"
        :label="`Wednesday `"
        value="wednesday"
        hide-details="auto"
        v-on="$listeners"
        v-bind="$attrs"
        dense
        outlined
      ></v-checkbox>
      <v-checkbox
        color="success"
        v-model="selectedDays"
        :label="`Thursday `"
        value="thursday"
        hide-details="auto"
        v-on="$listeners"
        v-bind="$attrs"
        dense
        outlined
      ></v-checkbox>
      <v-checkbox
        color="success"
        v-model="selectedDays"
        :label="`Friday `"
        value="friday"
        hide-details="auto"
        v-on="$listeners"
        v-bind="$attrs"
        dense
        outlined
      ></v-checkbox>
      <v-checkbox
        color="success"
        v-model="selectedDays"
        :label="`Saturday `"
        value="saturday"
        hide-details="auto"
        v-on="$listeners"
        v-bind="$attrs"
        dense
        outlined
      ></v-checkbox>
      <v-checkbox
        color="success"
        v-model="selectedDays"
        label="Sunday"
        value="sunday"
        hide-details="auto"
        v-on="$listeners"
        v-bind="$attrs"
        dense
        outlined
      ></v-checkbox>
    </v-card-text>
  </v-card>
</template>


<script>
export default {
  name: "WeekDays",
  props: {
    value: {
      default: () => [],
    },
    title: {
      type: String,
      default: "Preference Days",
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selectedDays: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    isAllSelected(val) {
      if (val) {
        this.selectedDays = [
          "monday",
          "tuesday",
          "wednesday",
          "thursday",
          "friday",
          "saturday",
          "sunday",
        ];
      } else {
        this.selectedDays = [];
      }
    },
  },
  data() {
    return {
      isAllSelected: false,
    };
  },
};
</script>

<style>
</style>